function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40",
  height: "40",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#545454",
  strokeLinejoin: "square",
  fill: "#FFF",
  cx: "20",
  cy: "20",
  r: "19.5"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#545454",
  strokeWidth: ".889"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.584 25.14a5.333 5.333 0 1010.667 0 5.333 5.333 0 00-10.667 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.917 27.806v-3.11a.444.444 0 00-.444-.445h-.889m.666-2.222a.222.222 0 110 .444.222.222 0 010-.444m-.666 5.778h2.666"
})), /*#__PURE__*/React.createElement("g", {
  stroke: "#445454"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.856 27.944l-3.288 2.22a.51.51 0 01-.593 0l-6.63-4.734a.51.51 0 01-.214-.415V9.948a.51.51 0 01.807-.415l6.333 4.523 6.844-4.888a.51.51 0 01.593 0l6.63 4.735a.51.51 0 01.214.416v4.041m-14.281-4.304v16.205m7.141-12.372V9.073",
  strokeWidth: "1.02"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: ".889",
  d: "M9.917 15.362h.445m-.445 2.667h.889m-.889 2.666h1.334m-1.334 2.667h.889"
}))))));